function getLogContainer() {
  let el = h.el(`.logs-content`);
  if(!el) {
    let logContainer = `
      <div id="debuglog-container" style="
        position: fixed;
        bottom: 0;
        right: 20px;
        width: 400px;
      ">
        <h3 style="display: flex; justify-content: space-between; align-items: center;">
          <span>Debug Log</span>
          <div style="font-size: 12px; cursor: pointer;" onclick="document.getElementById('debuglog-container').remove()">❌</div>
        </h3>
        <ul class="logs-content" 
          style="
            max-height: 140px;
            overflow: auto;
            border: 2px solid;
            border-radius: .5rem;
            padding: 12px;
            box-sizing: border-box;
            background: #fffcef;
            width: 100%;
          ">
        </ul>
      </div>
    `;
    document.body.insertAdjacentHTML('beforeend', logContainer);
    el = h.el(`.logs-content`);
  }
  return el;
}

export function debuglog(message) {
  const el = getLogContainer();
  let logItem = document.createElement('li');
  logItem.style.listStyle = 'none';
  logItem.innerHTML = `<div style="margin-bottom: 6px;">➡️ ${message}</div>`;
  el.insertBefore(logItem, el.firstChild);
}
